import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagePicker } from "../../../Shared/useImageCrop/ImagePicker";
import { baseUrl } from "../../../Config/baseUrl";
import RichTextEditorCustom from "../../../Shared/CustomRichTextEditor";

const AddBlog = () => {
  const [metaTitle, setMetaTitle] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("");
  const [category, setCategory] = useState("");
  const [subData, setSubData] = useState([]);
  const [subCategory, setSubCategory] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [data, setData] = useState([]);
  const [image, setImage] = useState(null);

  const navigate = useNavigate();

  const addBlog = (e) => {
    e.preventDefault();

    const reqbody = new FormData();
    reqbody.append("store", localStorage.getItem("store_id"));
    reqbody.append("title", title);
    reqbody.append("sub_title", subTitle);
    reqbody.append("meta_title", metaTitle);
    reqbody.append("meta_description", description);
    reqbody.append("Content", content);
    reqbody.append("images", image);
    reqbody.append("category", category);
    subCategory && reqbody.append("sub_category", subCategory);
    reqbody.append("auth", author);

    axios
      .post(`${baseUrl}/blog/blog-api/`, reqbody, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          navigate(-1);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => toast.error("Failed to add blog"));
  };

  const blogData = () => {
    axios
      .get(`${baseUrl}/blog/blog-category-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => setData(res?.data?.data || []))
      .catch((err) => toast.error(err.response?.data?.message));
  };

  const blogSubCategory = (id) => {
    axios
      .get(`${baseUrl}/blog/blog-subcategory-api/`, {
        params: { category_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => setSubData(res?.data?.data || []))
      .catch((err) => toast.error(err.response?.data?.message));
  };

  useEffect(() => {
    blogData();
  }, []);

  useEffect(() => {
    category && blogSubCategory(category);
  }, [category]);

  return (
    <div className="w-full px-3 md:px-6">
      <div className="bg-white shadow-lg rounded-lg p-4 md:p-6">
        <p className="text-xl font-bold text-center border-b pb-3">Add Blog</p>

        <form onSubmit={addBlog} className="mt-5">
          {/* FORM GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Title */}
            <div>
              <label className="text-sm font-semibold">Title</label>
              <input
                className="w-full p-2 border rounded"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            {/* Meta Title */}
            <div>
              <label className="text-sm font-semibold">Meta Title</label>
              <input
                className="w-full p-2 border rounded"
                onChange={(e) => setMetaTitle(e.target.value)}
              />
            </div>

            {/* Sub Title */}
            <div>
              <label className="text-sm font-semibold">Sub Title</label>
              <input
                className="w-full p-2 border rounded"
                onChange={(e) => setSubTitle(e.target.value)}
              />
            </div>

            {/* Author */}
            <div>
              <label className="text-sm font-semibold">Author</label>
              <input
                className="w-full p-2 border rounded"
                onChange={(e) => setAuthor(e.target.value)}
              />
            </div>

            {/* Description */}
            <div>
              <label className="text-sm font-semibold">Meta Description</label>
              <input
                className="w-full p-2 border rounded"
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* Category */}
            <div>
              <label className="text-sm font-semibold">Category</label>
              <select
                className="w-full p-2 border rounded"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Select category</option>
                {data.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Sub Category */}
            <div>
              <label className="text-sm font-semibold">Sub Category</label>
              <select
                className="w-full p-2 border rounded"
                value={subCategory}
                onChange={(e) => setSubCategory(e.target.value)}
              >
                <option value="">Select sub category</option>
                {subData.length > 0 ? (
                  subData.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))
                ) : (
                  <option>No Data Found</option>
                )}
              </select>
            </div>

            {/* Image */}
            <div>
              <label className="text-sm font-semibold">Image</label>
              <ImagePicker placeholder="Upload Image" handleChange={setImage} />
            </div>
          </div>

          {/* CONTENT */}
          <div className="mt-5">
            <label className="text-sm font-semibold">Content</label>
            <RichTextEditorCustom
              value={content}
              className="min-h-[200px]"
              onChange={setContent}
            />
          </div>

          {/* SUBMIT */}
          <div className="flex justify-center mt-6">
            <Button type="submit" variant="contained" className="!w-40">
              Add Blog
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBlog;
